import { FC, useState, Fragment, useMemo, useRef, useEffect } from "react";
import { useRequest, useSafeState } from "ahooks";
import { useInfiniteScroll } from "ahooks";
import { Head, Card } from "../components";
import { getItems } from "../api";
import { GoodsData, List, ApiData } from "../types/goods";
import InfiniteScroll from "react-infinite-scroll-component";
import numeral from "numeral";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import noListImg from "../test.png";

export const Home = () => {
  const [t, st] = useState<any>(0);
  // const { data: userData } = useRequest<any, any>(() => getUser(""));
  const [coupon, setCoupon] = useState<any>(0);
  const [prodUser, setProdUser] = useState<any>();
  const ref = useRef<HTMLDivElement>(null);
  const [pageConfig, setPageConfig] = useState({
    page: 1,
    pageSize: 6,
  });
  const [dataList, setData] = useState<List[]>([]);

  // Function to detect if we're in a webview environment
  const isWebviewEnvironment = () => {
    try {
      //@ts-ignore
      return typeof JsBridge !== "undefined" && JsBridge !== null;
    } catch (error) {
      return false;
    }
  };

  const { data, error, loading, refresh } = useRequest<ApiData, any>(
    (p) => {
      return getItems(pageConfig);
    },
    {
      refreshDeps: [pageConfig.page],
      cacheKey: `home-${pageConfig.page}`,
      staleTime: -1,
      cacheTime: -1,
    }
  );

  // useEffect(() => {
  //   const fetchUserProduction = async () => {
  //     const result = await getUserProduction();

  //     if (result && result.data) {
  //       setProdUser(result.data);
  //     } else {
  //       console.warn("No data received from getUserProduction");
  //     }
  //   };

  //   fetchUserProduction();
  // }, []);

  // console.log(" user", prodUser);

  const fetchMoreData = () => {
    setPageConfig({
      ...pageConfig,
      page: pageConfig.page + 1,
    });

    refresh();
  };

  useEffect(() => {
    if (data?.data?.list?.length) {
      setData([...dataList, ...data.data.list]);
    }
  }, [data]);

  useEffect(() => {
    let f = 0;
    let c = 0;
    try {
      // @ts-ignore
      f = JSON.parse(JsBridge?.getUserInfo?.())?.integral ?? 0;
      // @ts-ignore
      c = JSON.parse(JsBridge?.getUserInfo?.())?.coupon ?? 0;
      st(f);
      setCoupon(c);
    } catch (e) {
      // @ts-ignore
      dsBridge.call("getUserInfo", "getUserInfo", function (v) {
        st(JSON.stringify(JSON.parse(v)?.integral));
      });
      // @ts-ignore
      dsBridge.call("getUserInfo", "getUserInfo", function (v) {
        st(JSON.stringify(JSON.parse(v)?.coupon));
      });
    }
  }, []);

  const handleOpenTask = () => {
    try {
      //@ts-ignore
      JsBridge?.openNativePage?.(JSON.stringify({ pageName: "get-integral" }));
    } catch (error) {
      //@ts-ignore
      dsBridge.call(
        "openNativePage",
        JSON.stringify({ pageName: "get-integral" })
      );
    }
  };

  const checkLoginStatus = () => {
    let userInfo;
    //@ts-ignore
    const loginStatus = JsBridge?.isLogin?.();
    if (!loginStatus) {
      try {
        //@ts-ignore
        JsBridge?.openNativePage?.(JSON.stringify({ pageName: "login" }));
      } catch (error) {
        //@ts-ignore
        dsBridge?.call?.(
          "openNativePage",
          JSON.stringify({ pageName: "integral-feedback" })
        );
      }
    } else {
      // @ts-ignore
      userInfo = JsBridge?.getUserInfo?.();
      var canCustomerServer = null;
      var option = {
        openUrl: "https://111.173.119.203:45443",
        token: "67aa98823a51c1f53818982058417121",
        kefuid: "",
        isShowTip: false, // Disable auto display of chat button
        mobileIcon: "",
        pcIcon: "",
        windowStyle: "center",
        domId: "customerServerTip",
        insertDomNode: "body", // Append chat window to body
        sendUserData: {
          uid: userInfo.uId,
          nickName: userInfo.nickName,
          phone: "",
          sex: "",
          avatar: userInfo.avatar,
          openid: "",
        },
      };
      // @ts-ignore
      if (!canCustomerServer) {
        // @ts-ignore
        canCustomerServer = new initCustomerServer(option);
        // @ts-ignore
        canCustomerServer.init();
        // @ts-ignore
        canCustomerServer.getCustomeServer(); // Show chat window
      } else {
        // @ts-ignore
        canCustomerServer.getCustomeServer();
        console.log("Chat server already initialized.");
      }
      // @ts-ignore
      //  const name = `DYLS-${userInfo.nic}`
      //  const hrefLink = `https://111.173.119.203:45443/chat/mobile?noCanClose=1&token=67aa98823a51c1f53818982058417121&uid=${userInfo.uId}&nickName=${userInfo.nickName}&avatar=${userInfo.avatar}`
      // window.location.href = hrefLink
    }
  };

  const noList = data?.data?.list.length === 0;

  // Check if we should show error page for non-webview environment
  const shouldShowErrorPage = !isWebviewEnvironment();

  // Error page component
  const ErrorPage = () => (
    <div className="w-screen h-screen flex justify-center items-center bg-white">
      <div className="flex flex-col justify-center items-center px-4 text-center">
        {/* 404 Image */}
        <div className="w-60 h-40 mb-1">
          <img
            src="404.webp"
            alt="404"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    </div>
  );

  // If not in webview environment, show only error page
  if (shouldShowErrorPage && !data) {
    return <ErrorPage />;
  }

  return (
    <div className="container " ref={ref}>
      <Head />
      <div className="w-full relative mt-[-54px]">
        <img alt="" src="headblur.png" className=" w-full mt-10" />
        <div className="container px-4 absolute bottom-[-33px]">
          <div className=" jf-card  flex flex-col">
            <div className=" flex w-full pt-[10px] items-center justify-between text-orange-secondary">
              <div className="flex flex-col gap-[4px]">
                <div className="flex items-end leading-[32px] gap-2">
                  <span className="text-[32px]">{t}</span>
                  <span className="text-black/60 text-sm">积分</span>
                </div>
                <span className="new_redeem">
                  兑换劵 : <span className="new_redeem_num">{coupon}</span> 张
                </span>
              </div>
              <button
                onClick={handleOpenTask}
                className="border-[1px] border-[#FF9153] px-4 py-[4px] rounded-full font-medium text-[14px]"
              >
                获取积分
              </button>
            </div>
            {/* <span className=" text-[9px] text-orange-secondary">
              (老版本始终显示0但不影响兑换，建议更新到最新客户端版本)
            </span> */}
          </div>
        </div>
      </div>

      {loading && dataList.length === 0 && (
        <div className="mt-[45px] px-4">
          <SkeletonTheme
            direction="ltr"
            baseColor="#E1E1E1"
            highlightColor="#00000030"
          >
            <div className="grid grid-cols-2 gap-3 pb-3">
              {[...Array(6)].map((_, index) => (
                <Skeleton
                  key={index}
                  className="rounded-lg w-[250px] h-[250px] xl:w-[600px]"
                />
              ))}
            </div>
          </SkeletonTheme>
        </div>
      )}

      {noList ? (
        <div className=" w-screen h-[70vh] flex justify-center items-center">
          <div className=" flex flex-col justify-center items-center">
            <img className=" h-[184px]" src={noListImg} alt="" />
            <h1 className="nolist_head">这里还没有商品</h1>
            <span className=" nolist_des">稍后再试</span>
          </div>
        </div>
      ) : (
        <div className="jf-infinitescroll" id="scrollableDiv">
          <InfiniteScroll
            className="grid grid-cols-2 gap-3 pb-3"
            dataLength={dataList.length}
            next={fetchMoreData}
            hasMore={dataList.length < (data?.data?.total ?? 1)}
            loader={<h4></h4>}
            scrollableTarget="scrollableDiv"
          >
            {dataList?.map((i, k) => (
              <Card key={i.id} data={i} />
            ))}
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
};
